// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1pJcQ","productName":"Table_productName__1v7Cx"};